import React, { FC } from 'react'
import { Container } from '../../common/components/Container'
import { Maintenance } from './Maintenace'

export const ContainerWithAnnounce: FC = ({ children }) => {
  return (
    <Container innerWidth={'800px'}>
      <Maintenance radius={4} className={'mb24'} />
      {children}
    </Container>
  )
}
